import { TitleText } from '@calendly/ui/components/typography'

import {
  formatDateParams,
  getLastPeriodDateParams,
} from 'features/reporting'

import { Trend } from './components'
import { ErrorState } from '../../components/error_tile'
import { LoadingTile } from '../../components/loading_tile'
import { Tile } from '../../components/tile'

export const AnalyticsTile = ({ start, end, fetchMeetings, timezone, status, name, componentName }) => {
  const current = fetchMeetings({
    status,
    ...formatDateParams({ start, end, timezone })
  })

  const past = fetchMeetings({
    status,
    ...getLastPeriodDateParams({ start, end, timezone }),
  })

  const hasError = current.isError || past.isError
  const isReady = !current.isFetching && !past.isFetching

  if (hasError) return <ErrorState />
  if (!isReady) return <LoadingTile />

  return (
    <Tile
      componentName={componentName}
      icon={<TitleText as="div" level={3} size="small">{current.data.count}</TitleText>}
      name={name}
      controls={<Trend currentCount={current.data.count} pastCount={past.data.count} />}
    />
  )
}
